import { Component } from '@angular/core';
import { ButtonSize, ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/1.0/message.component';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'formly-array-type',
  templateUrl: './array-type.component.html',
  styleUrls: ['./array-type.component.scss'],
  standalone: true,
  imports: [NgIf, MessageComponent, FormlyModule, NgFor, ButtonComponent, TranslateModule],
})
export class ArrayTypeComponent extends FieldArrayType {
  buttonSize = ButtonSize;
  buttonStyle = ButtonStyle;
  messageType = MessageType;
}
